import {create} from 'zustand'
import { CARD_SORT_TYPE, CARD_TYPE, DEFAULT_FILTERS, ICategory, ICritery, IFestFilters, IFestival, IFormField, IGanre, IHoneycombs, IMilestone, ILand, IProject, IProjectMilestone, ITrack } from './interfaces'
import { createJSONStorage, devtools, persist } from 'zustand/middleware' 
import { ID } from "src/libs/interfaces/layouts";   
import { getStorage, IUser } from '@/settings/zustand';

export const useFestAdminStore: any = create(devtools<IFestAdminStore>((set: any, get: any ) => ({ 
    client: { },
    setClient: ( client: any ) => set( ( ) => ({ client }) ),
    festival: {} as IFestival,
    land: {} as ILand
})))

export const useFestStore : any = create( devtools( persist<IFestStore>(
    (set:any, get:any) => ({ 
        cardType: CARD_TYPE.NONE,
        setCardType: (cardType:CARD_TYPE) => set(() => ({ cardType })),
        cardSort: CARD_SORT_TYPE.ACS,
        setCardSort: (cardSort: CARD_SORT_TYPE) => set( () => ({cardSort}) ),
        filters: DEFAULT_FILTERS,
        setFilter: (filters: IFestFilters) => set(() => {  
            return {filters}
        }),
        search: "",
        setSearch: (search: string) => set( () => {
            return { search }
        }),
        isVerified: true,
        isNotVerified: true
    }),
    {
        name: 'pe-fest-storage', 
        storage: createJSONStorage( getStorage ), 
    } 
)))

export const useFestDataStore: any = create( devtools<IFestDataStor> ( 
    (set: any, get: any) => ({
        festId: -1,
        festival: {} as IFestival,
        setFestival: ( festival:IFestival) => set( () => ({ festival }) ),
        lastUpdateFestival : Date.now(),
        setLastUpdateFestival : ( lastUpdateFestival: number ) => set( () => ({ lastUpdateFestival }) ), 
        site: {} as ILand,
        tracks: [] as ITrack[],
        setTracks: (tracks: ITrack[] ) => set( () => ({ tracks }) ),
        honeycombs: [] as IHoneycombs[],
        setHoneycombs: (honeycombs: IHoneycombs[] ) => set( () => ({ honeycombs }) ),
        ganres: [] as IGanre[],
        setGanres: (ganres: IGanre[] ) => set( () => ({ ganres }) ),
        milestones: [] as IMilestone[],
        setMilestones: (milestones: IMilestone[] ) => set( () => ({ milestones }) ),
        categories: [] as ICategory[],
        setCategories: (categories: ICategory[] ) => set( () => ({ categories }) ),
        criteries: [] as ICritery[],
        setCriteries: (criteries: ICritery[] ) => set( () => ({ criteries }) ),
        isPatternAlarm: true,
        isComment: true,
        setIsComment: (isComment:boolean) => {
            console.log( isComment )
            set({isComment : isComment})
        } 
     }),
))

export const useFestProjects : any = create( devtools<IFestProjectsProps>(
    (set: any, get: any) => ({
        currentProject : {} as IProject,
        setCurrentProject: (currentProject: IProject ) => set({ currentProject }),
        currentProjectMilestones: [] as IProjectMilestone[],
        setCurrentProjectMilestones: (currentProjectMilestones : IProjectMilestone[]) => set({currentProjectMilestones}),
        isBlockedUpdate: false, 
        setIsBlockedUpdate: ( isBlockedUpdate: boolean ) => set({ isBlockedUpdate }),
        extendFieldsTemp: []
    }), 
))

export const useFestMyProjects : any = create( devtools<IFestMyProjectsProps> (
    (set: any, get: any) => ({
        myProjects : [] as IProject[],
        setMyProjects: (myProjects: IProject[] ) => set({ myProjects }),
        unverificiedProjects: []  as IProject[],
    }) 
))

export const useFestStatistic : any = create( devtools<IFestStatistics>(
    (set: any, get:any) => ({
        membersParams: {} as membersParamsProps, 
        setMembersParams : ( membersParams: membersParamsProps ) => set({ membersParams }),
        usersParams: { filters: { tracks:[] } } as usersParamsProps, 
        setUsersParams: ( usersParams: usersParamsProps ) => set({usersParams }),
        specialParams: {} as specialsParamsProps,
        setSpecialsParams : ( specialParams: specialsParamsProps ) => set({ specialParams }),
        selected: [ "#" ],
        setSelected: (selected: string[] ) => set({selected }),
        uniqUsers: [] as IUser[],
        schoolRows: [
            {
                scope: "col",
                title: "#", 
                width: 55
            },
            {
                scope: "school",
                title: "School", 
            },
            {
                scope: "guardian",
                title: "Guardian", 
            },
            {
                scope: "guardian_2",
                title: "Guardian 2", 
            },
            {
                scope: "members",
                title: "Projects's members", 
            },
            {
                scope: "tutors",
                title: "Projects's tutors", 
            },
            {
                scope: "count",
                title: "Projects count",
                // width: 80,
            },
        ],
        contextMethods: {
            hiddenRow: ( rowCollectionID: string, id: string ) => {            
                console.log( rowCollectionID, id )
                set({
                    [rowCollectionID]: useFestStatistic.getState()[rowCollectionID].map((row: any) => {
                        if( row.scope === id ) {
                            row.isHidden = !row.isHidden
                        }
                        return row
                    })
                })           
            }
        }
    }) 
))

export const useFestExport : any = create( devtools( 
    (set: any, get: any) => ({ 
        festival: {},
        land: {},
        item: {},
        clear: () => set({
            festival: {},
            land: {},
            item: {},
            clear: () => clear()
        }, true)
    }) 
))
const clear = () => { 
    try {
        useFestExport.set({
            festival: {},
                land: {},
                item: {},
                clear: () => clear()
        })
    }
    catch(err) {
        console.error(err)
    }    
}

export interface IFestAdminStore {
    client: any
    setClient: ( client: any ) => void
    festival: IFestival
    land: ILand
}

export interface membersParamsProps {
    filters: any,
    sort: "order" | "alphabet" | "rating" | "nomination" | "abc" | "desc",
    fields: "isFields" | "isCriteries"
}

export interface usersParamsProps {
    filters: any,
    sort: "order" | "alphabet",
}

export interface specialsParamsProps {
    filters: any,
    sort: "order" | "alphabet",
    fields: string[],
    selected: string[]
}

// filters for statistics forms 
export interface IFestStatistics {

    //See ProjectsStatisticForm.tsx
    membersParams: membersParamsProps
    setMembersParams : ( membersParams: membersParamsProps ) => void

    // See FullMemberExpertsForm.tsx
    usersParams : usersParamsProps
    setUsersParams: ( usersParams: usersParamsProps ) => void

    // See SpecialStatisticForm.tsx
    specialParams: any,
    setSpecialsParams : ( specialParams: any ) => void,

    // ?
    selected: string[],
    setSelected: (selected: string[] ) => void

    //SpecialTitleRow.tsx
    uniqUsers: IUser[]

    // SchoolsForm.tsx
    schoolRows: any[]

    // context tables methods -- see SchoolsForm
    contextMethods: any
}

export interface IFestMyProjectsProps {
    unverificiedProjects: IProject[]
    myProjects: IProject[]
    setMyProjects: ( myProjects: IProject[] ) => void
}

export interface IFestProjectsProps {
    currentProject: IProject
    setCurrentProject: (currentProject: IProject) => void    
    currentProjectMilestones: IProjectMilestone[]
    setCurrentProjectMilestones: (currentProjectMilestones : IProjectMilestone[]) => void
    isBlockedUpdate: boolean, 
    setIsBlockedUpdate: (isBlockedUpdate: boolean) => void,
    extendFieldsTemp: IFormField[][]
}

export interface IFestStore {
    cardType: CARD_TYPE,
    setCardType: (cardType: CARD_TYPE) => void,
    cardSort: CARD_SORT_TYPE,
    setCardSort: (cardSort: CARD_SORT_TYPE)=> any
    filters: IFestFilters
    setFilter : (filters: IFestFilters) => void
    search: string,
    setSearch: (search: string) => void,    
    isVerified: boolean,
    isNotVerified: boolean
}

export interface IFestDataStor {
    festId: ID,
    festival: IFestival,
    setFestival: (festival: IFestival) => void,
    lastUpdateFestival: number,
    setLastUpdateFestival : ( lastUpdateFestival: number ) => void 
    site: ILand
    tracks: ITrack[]
    setTracks: (tracks: ITrack[] ) => void
    honeycombs:IHoneycombs[]
    setHoneycombs: (honeycombs: IHoneycombs[] ) => void
    ganres: IGanre[] 
    setGanres: (ganres: IGanre[] ) => void
    milestones: IMilestone[] 
    setMilestones: (milestones: IMilestone[] ) => void
    categories: ICategory[] 
    setCategories: (categories: ICategory[] ) => void
    criteries: ICritery[]
    setCriteries: (criteries: ICritery[] ) => void
    isPatternAlarm: boolean
    isComment: boolean
    setIsComment: (isComment:boolean) => void
}